import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, FILTERS, REPORTS } from './consts';

export const getPatients = path([$, LIST]);
export const getPatient = (id) => path([$, LIST, id]);
export const getPatientProp = (id) => (name) => path([$, LIST, id, name]);
export const getPatientsFilters = path([$, FILTERS]);
export const getPatientsReports = path([$, REPORTS]);
